<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-table-tennis</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.acttiv') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 15px 0 15px;" />       -->
    </v-toolbar>
    <v-layout wrap v-show="!collapseContent">
      <v-flex xs4 text-right style="padding-right: 20px">
        {{ $t('acttiv.primaryColor') }}:
      </v-flex>
      <v-flex xs8>
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActtivPrimaryColor"
          :onChangeColor="handleChangePrimaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.secundaryColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActtivSecundaryColor"
          :onChangeColor="handleChangeSecundaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.titleColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActtivColor"
          :onChangeColor="handleChangeTitleColor"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import axios from 'axios'
  import api from '@/services/api'
  import CustomColorPicker from '@/components/CustomColorPickerV2'
  export default {
    components:{
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      DviewLink: null,
      typesActivity: null
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLink = response.DviewLink
          this.handleGetTypeActivities()
        })
      },
      handleChangePrimaryColor (color) {
        this.content.ActtivPrimaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeSecundaryColor (color) {
        this.content.ActtivSecundaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeTitleColor (color) {
        this.content.ActtivColor = color
        this.handleChangeIsModified()
      },
      handleGetTypeActivities () {
        this.data = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.DviewLink}/dtouch-type-activity`)
          .then(response => {
            this.typesActivity = [
              {
                ID: 0,
                Name: 'TODOS'
              },
              {
                ID: 1,
                Name: response.data.TypeActivity01 && response.data.TypeActivity01.length > 0 ? response.data.TypeActivity01 : 'Type 01'
              },
              {
                ID: 2,
                Name: response.data.TypeActivity02 && response.data.TypeActivity02.length > 0 ? response.data.TypeActivity02 : 'Type 02'
              },
              {
                ID: 3,
                Name: response.data.TypeActivity03 && response.data.TypeActivity03.length > 0 ? response.data.TypeActivity03 : 'Type 03'
              }
            ]
          })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

